import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React from 'react';
import { isFilledString } from '../../utils/string.js';

var _excluded = ["children", "disabled", "onClick"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * AnchorButton
 * - href가 있으면 a태그, 없으면 button태그를 적용합니다.
 */
function AnchorButton(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleClickAnchor = function handleClickAnchor(event) {
    if (disabled) {
      event.preventDefault();
      return;
    }
    return onClick === null || onClick === void 0 ? void 0 : onClick(event);
  };
  if (isFilledString(props.href)) {
    return /*#__PURE__*/React.createElement("a", _objectSpread(_objectSpread({}, props), {}, {
      onClick: handleClickAnchor
    }), children);
  } else {
    return /*#__PURE__*/React.createElement("button", _objectSpread(_objectSpread({
      type: "button"
    }, props), {}, {
      disabled: disabled,
      onClick: onClick
    }), children);
  }
}

export { AnchorButton as default };
